module.exports = "/_next/static/images/Delivery@2x-3a00e8e43fa6c05675e847d4c737de41.webp";